(() => {
  const managerKey = '__treyaProductDetailsManager';
  if (window[managerKey]) {
    window[managerKey].initAll(document);
    return;
  }

  const instances = new Map();

  const updateSection = (section, variant) => {
    if (!variant) return;

    section.querySelectorAll('[data-variant-title]').forEach((element) => {
      const value = variant.title || '';
      if (element.textContent !== value) element.textContent = value;
    });
    section.querySelectorAll('[data-variant-id]').forEach((element) => {
      const value = String(variant.id || '');
      if (element.textContent !== value) element.textContent = value;
    });
    section.querySelectorAll('[data-variant-availability]').forEach((element) => {
      const value = variant.available ? element.dataset.availableLabel : element.dataset.unavailableLabel;
      if (element.textContent !== value) element.textContent = value;
    });

    const skuRow = section.querySelector('[data-variant-sku-row]');
    const skuValue = skuRow?.querySelector('[data-variant-sku]');
    if (skuRow && skuValue) {
      if (skuValue.textContent !== (variant.sku || '')) skuValue.textContent = variant.sku || '';
      skuRow.hidden = !variant.sku;
    }

    const barcodeRow = section.querySelector('[data-variant-barcode-row]');
    const barcodeValue = barcodeRow?.querySelector('[data-variant-barcode]');
    if (barcodeRow && barcodeValue) {
      if (barcodeValue.textContent !== (variant.barcode || '')) barcodeValue.textContent = variant.barcode || '';
      barcodeRow.hidden = !variant.barcode;
    }

    section.querySelectorAll('[data-option-index]').forEach((element) => {
      const index = Number(element.dataset.optionIndex);
      const value = variant.options?.[index] || '';
      if (element.textContent !== value) element.textContent = value;
    });
  };

  const init = (section) => {
    if (!(section instanceof HTMLElement) || section.dataset.treyaDetailsInitialized === 'true') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => updateSection(section, data?.variant));
    section.dataset.treyaDetailsInitialized = 'true';
    instances.set(section, () => {
      unsubscribe();
      delete section.dataset.treyaDetailsInitialized;
    });
  };

  const initAll = (scope) => {
    if (scope.matches?.('[data-treya-product-details]')) init(scope);
    scope.querySelectorAll?.('[data-treya-product-details]').forEach(init);
  };

  const destroyWithin = (scope) => {
    instances.forEach((destroy, section) => {
      if (section === scope || scope.contains?.(section)) {
        destroy();
        instances.delete(section);
      }
    });
  };

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

  window[managerKey] = { initAll, destroyWithin };
  initAll(document);
})();
